import { Injectable, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { FormsBase } from 'src/app/common-components/forms-base/forms-base';
import { DeviceDetailForm, DeviceDetailFormValue } from '../models/device-detail-form';
import { DeviceDetailSaveModel } from '../models/device-detail-save.model';
import { DeviceDetailView } from '../models/device-detail-view.model';

@Injectable()
export class DeviceDetailFormService extends FormsBase implements OnDestroy {
   private destroyed$ = new Subject<void>();

   constructor(fb: UntypedFormBuilder, private store: Store, private action: Actions) {
      super();

      const form: DeviceDetailForm = {
         account: fb.control(null),
         accountName: fb.control(null),
         createDate: fb.control(null),
         createUser: fb.control(null),
         deviceId: fb.control(null),
         deviceTypeId: fb.control(null, Validators.required),
         description: fb.control(null),
         lastFirmwareReported: fb.control(null),
         baseStationHandsets: fb.control([]),
         lastProvisionedDate: fb.control(null),
         lastZtResponse: fb.control(null),
         macAddress: fb.control(null, [Validators.required, Validators.pattern('^\\s*[a-fA-F0-9]{12}\\s*$')]),
         notes: fb.control(null),
         serialNumber: fb.control(null),
         updateDate: fb.control(null),
         updateUser: fb.control(null),
         ztStatus: fb.control(null),
      };

      this.form = fb.group(form);
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   updateDevice(device: DeviceDetailView): void {
      if (!device) {
         return;
      }

      const formValue: Partial<DeviceDetailFormValue> = {
         account: device.account,
         deviceId: device.deviceId,
         deviceTypeId: device.deviceTypeId,
         lastFirmwareReported: device.lastFirmwareReported,
         lastProvisionedDate: device.lastProvisionedDate,
         lastZtResponse: device.lastZtResponse,
         macAddress: device.macAddress,
         notes: device.notes,
         serialNumber: device.serialNumber,
         ztStatus: device.ztStatus,
         description: device.description,
         baseStationHandsets: device.baseStationHandsetsConnection,
      };

      this.form.patchValue(formValue);
      this.markAsUntouchedAndPristine();
   }

   getValue(deviceId: number | null): DeviceDetailSaveModel {
      const value = this.form.value as DeviceDetailFormValue;
      return {
         accountId: value.account?.accountId ?? null,
         deviceId: deviceId,
         deviceTypeId: value.deviceTypeId,
         lastFirmwareReported: value.lastFirmwareReported,
         lastProvisionedDate: value.lastProvisionedDate ?? null,
         lastZtResponse: value.lastZtResponse,
         macAddress: value.macAddress,
         notes: value.notes,
         serialNumber: value.serialNumber,
         ztStatus: value.ztStatus,
         description: value.description,
         baseStationHandsets:
            value.baseStationHandsets && value.baseStationHandsets.length > 0
               ? value.baseStationHandsets.map((handset) => ({
                    baseStationHandsetId: handset.baseStationHandsetId,
                    phoneId: handset.phoneId,
                    deviceId: deviceId,
                    sortId: handset.sortId,
                    isDeleted: handset.isDeleted,
                    fields: [],
                 }))
               : [],
      };
   }
}
